import { DestinationDetail } from '../types/types';
import { DestinationCardContainer, DestinationCardIcon } from './DestinationCard.styles';
import { usePrequelContext } from '../contexts';

type DestinationCardProps = {
  destination: DestinationDetail;
  isDisabled?: boolean;
  isSelected?: boolean;
  onSelect?: (destinationId: string) => void;
};

export const DestinationCard = ({
  destination,
  isDisabled = false,
  isSelected = false,
  onSelect,
}: DestinationCardProps) => {
  const { setSelectedDestination, selectedDestination } = usePrequelContext();

  const handleClick = () => {
    if (!isDisabled) {
      if (onSelect) {
        onSelect(destination.id);
      } else {
        setSelectedDestination(destination.id);
      }
    }
  };

  const isCurrentlySelected = selectedDestination === destination.id;

  return (
    <DestinationCardContainer
      data-disabled={isDisabled}
      data-selected={isCurrentlySelected}
      onClick={handleClick}
      data-test={`card-id-${destination.id}`}
    >
      <DestinationCardIcon>
        <destination.Icon height={40} width={40} />
      </DestinationCardIcon>
      <div>{destination.name}</div>
    </DestinationCardContainer>
  );
};
